import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { SwitchCase } from "./Switch";

interface SwitchCaseContainerProps {
    prevCaseConditions: Array<EvaluableProp<boolean>>;
    condition: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: SwitchCaseContainerProps) => {
    const allPrevCaseConditionNegative = ownProps.prevCaseConditions.every(
        x => !ownProps.processEvaluableProp(state, x)
    );
    const conditionPositive = ownProps.processEvaluableProp(state, ownProps.condition);

    return {
        visible: allPrevCaseConditionNegative && conditionPositive,
    };
};

export const SwitchCaseContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(SwitchCase)))
);
